import SalesforceIcon from '../pages/environments/page/Salesforce.svg?react';
import SnowflakeIcon from '../pages/environments/page/snowflakeIcon.svg?react';
import Data360Icon from '../pages/environments/page/Data360Icon.svg?react';
import ServiceNowIcon from '../pages/environments/page/serviceNowIcon.svg?react';
import { OrgType } from '../../apis/facades/types/crmOrgsApiFacade.types';

interface PlatformIconProps {
  orgType?: OrgType;
  size?: number;
}

/**
 * Displays the appropriate platform icon based on org type.
 * @param orgType - The type of organization (Salesforce, Snowflake, Data360, or ServiceNow)
 * @param size - Icon size in pixels (default: 16)
 */
export const PlatformIcon = ({ orgType, size = 16 }: PlatformIconProps) => {
  switch (orgType) {
    case OrgType.Snowflake:
      return <SnowflakeIcon style={{ width: size, height: size }} />;
    case OrgType.Data360:
      return <Data360Icon style={{ width: size, height: size }} />;
    case OrgType.ServiceNow:
      return <ServiceNowIcon style={{ width: size, height: size }} />;
    default:
      return <SalesforceIcon />;
  }
};
